<ion-radio-group [ngModel]="selectedOptionIndex()">
	@for (article of optionGroup.articles; track article; let optionIndex = $index) {
		@if (!isHidden(article)) {
			<ion-item
				(click)="onSelectionChange(article)"
				[disabled]="isDisabled(article)"
				class="ion-no-padding ion-text-wrap"
				lines="none"
				mode="md"
			>
				@if (price(article) > 0) {
					<span class="price" slot="end">
						@if (!fullPrice()) {
							+
						}
						{{ numberToCurrency(price(article), currency) }}
					</span>
				}
				<ion-radio [value]="optionIndex" slot="end"></ion-radio>
				@if (article?.assets.medium) {
					<ion-img [src]="article?.assets?.medium" class="item-img"></ion-img>
				}
				@if (!article?.assets.medium) {
					<ion-img class="item-img" src="../../../assets/topgolf/header_logo.svg"></ion-img>
				}
				<ion-label class="display-block">
					<div class="text_wrap">
						<span>
							{{ article.name | langObservable | async }}
							@if (
								isAllergens(article) || isAddit(article) || isHaveAnyValueMoreZero(article) || article?.info?.de?.length > 0
							) {
								<ion-button (click)="openInfoClick(article); $event.stopPropagation()" class="content-only" slot="end">
									<ion-icon slot="icon-only" src="/assets/topgolf/info.svg"></ion-icon>
								</ion-button>
							}
						</span>
					</div>
					<!-- <app-tag [tags]="article.tags"></app-tag> -->
				</ion-label>
			</ion-item>
		}
	}
	@if (optionGroup.articles.length > 5) {
		<div (click)="showFirstArticles = !showFirstArticles" class="mehr-articles">
			<div>
				<h5>{{ 'common.show_more' | translate }}</h5>
				<ion-icon [class.rotate]="!showFirstArticles" name="chevron-down-outline"></ion-icon>
			</div>
		</div>
	}
</ion-radio-group>
